module.exports = __webpack_public_path__ + "img/soccerboard76.9dc64895.jpg";